export enum PlaybackRate {
    Slower = 'SLOWER',
    Slow = 'SLOW',
    Normal = 'NORMAL',
}